export default __webpack_public_path__ + "static/media/dinning_icon.54bfab08.svg";